import { render } from "./Enviar.vue?vue&type=template&id=79516ea2"
const script = {}
script.render = render

export default script